<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import type { IChannelDTO } from "../../services/DTO";
  import Button from "../Button.svelte";
  import ClfDropdown from "../Form/Fields/Dropdown/ClfDropdown.svelte";
  import Input from "../Form/Fields/Input.svelte";
  import FormField from "../Form/FormField.svelte";
  import Icon from "../Icon.svelte";

  export let records: ICompanyInvoiceDashboardDTO[] = [];
  export let entityId: number = 0;
  export let searchValueOwnershipId : number;
  export let searchValueImportoPagato : boolean;
  export let searchValueDataScadenzaFrom : Date;
  export let searchValueDataScadenzaTo : Date;


  const dispatch = createEventDispatcher();

  function onLoad() {
    dispatch("load", { entityId: entityId });
  }

    function onClearSearch(_event: Event) {
      searchValueOwnershipId = null;
      searchValueImportoPagato = null;
      searchValueDataScadenzaFrom = null;
      searchValueDataScadenzaTo = null;
      dispatch("search", entityId);
    }

    function onSearchClick(oid: number, pagato: boolean, scadenzaDa: Date, scadenzaA: Date, _event: Event) {
      searchValueOwnershipId = oid;
      searchValueImportoPagato = pagato;
      searchValueDataScadenzaFrom = scadenzaDa;
      searchValueDataScadenzaTo = scadenzaA;
      dispatch("search", entityId);
    }

  onMount(() => onLoad());
</script>

<div >
<div class="tile is-ancestor dashboard-tiles noselect">
  {#each records as thing (thing.ownership.oid)}
  <div class="tile is-parent">
    <article
      class="tile is-child box has-text-centered dashboard-box-default"
    >
    <a on:click={onSearchClick(thing.ownership.oid, null, null, null)}><p class="is-underlined subtitle dashboard-tile-text">{thing.ownership.name}</p></a>
    <div class="columns">
      <a on:click={onSearchClick(thing.ownership.oid, true, null, null)}  class="column is-4 title is-size-3  has-text-success">
        <div class="">{thing.paidinvoices}<p class="is-underlined subtitle is-size-6 has-text-success">OK</p></div>
      </a>
      <a on:click={onSearchClick(thing.ownership.oid, false, new Date(new Date().getTime()-3*30*24*3600*1000), new Date(new Date().getTime()))}  class="column is-4 title is-size-3  has-text-warning">
        <div class="">{thing.unpaidinvoicesrecent}<p class="is-underlined subtitle is-size-6 has-text-warning">&lt;3m</p></div>
      </a>
      <a on:click={onSearchClick(thing.ownership.oid, false, null, new Date(new Date().getTime()-3*30*24*3600*1000))}  class="column is-4 title is-size-3  has-text-danger">
        <div class="">{thing.unpaidinvoicesolder}<p class="is-underlined subtitle is-size-6 has-text-danger">&gt;3m</p></div>
      </a>
      </div>

    </article>
  </div>
  {/each}
</div>
</div>

<style>
  .dashboard-tiles {
    margin-top: 0.5rem;
  }
  .dashboard-tile-text {
    color: #f8f8f8;
  }
  .dashboard-tile-text-dark {
    color: #7799bd;
  }
  .dashboard-box-default {
    background-color: #7799bd;
  }
  .dashboard-box-alert {
    background-color: #ffe4e1;
  }
  .dashboard-box-warn {
    background-color: #ffffe0;
  }
  .dashboard-box-ok {
    background-color: #9acd32;
  }
</style>
